import { parse as t } from "date-fns";
import * as e from "yup";
import { YUP_CHECK_MIN_DATE_ERROR_MESSAGE as r } from "./extendYupMethods.js";
const n = e.string().trim().matches(/^\d+$/, "Введіть значення з 2 цифр").length(2, "Введіть значення з 2 цифр"), i = /^\d{2}X[A-Z\d]{13}$/i, a = e.string().trim().test("checkInvalidDate", "Невірний формат", (t2) => !t2 || "Invalid Date" !== new Date(t2).toString()).test("checkMinDate", r, (e2) => {
  if (!e2) return true;
  return t(e2.replace(/T.*$/, ""), "yyyy-MM-dd", /* @__PURE__ */ new Date()).getFullYear() >= 1900;
});
export {
  i as VALIDATION_EIC_REGEXP,
  a as yupValidateDate,
  n as yupValidateEicSymbol
};
//# sourceMappingURL=fieldValidations.js.map
